function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModernGem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 245,
    viewBox: "0 0 308 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 225.11 4.927 L 76.239 4.927 L 6.7 96.95 L 155.082 238.048 L 301.015 96.95 L 225.11 4.927 Z",
    stroke: "black",
    style: {
      strokeWidth: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModernGem);
export default __webpack_public_path__ + "static/media/modern-gem.a578fd3141549e7a7b35e0bf10e71180.svg";
export { ForwardRef as ReactComponent };